import React, { useContext, useEffect } from "react";
import { useEngagementResponse } from "./store";
import { CustomerProps } from "./ShowCustomer";

function EngagementResponse() {
  const { fetchEngagementResponse, data } = useEngagementResponse();
  const { caseId } = useContext(CustomerProps)
  useEffect(() => {
    fetchEngagementResponse(caseId);
  }, [caseId]);

  return (
    <div>
      {Array.isArray(data) &&
        data.map((text) => {
          const responseLines = text.split('<br>');
          return (
            <div className="border border-warning rounded m-2 p-2">
              {responseLines.map((line, index) => (
                <div key={index}>{line}</div>
              ))}
            </div>
          );
        })
      }
    </div>
  );
}

export default EngagementResponse;
